<template>
  <div class="page-view"><thankyou-message /></div>
</template>

<script>
import thankyouMessage from "@/mycfm/components/ThankyouMessage";

export default {
  components: {
    thankyouMessage
  }
};
</script>
